import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  pages: {},
  totalCount: 0,
  loading: false,
  sort: 'VENDOR_ASC',
  filter: {
    vendor: undefined,
  },
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const vendorManagementSlice = createSlice({
  name: 'vendorManagement',
  initialState,
  reducers: {
    loadVendors(state, action) {
      const { page, items, totalCount } = action.payload;
      state.pages[page] = items;
      state.totalCount = totalCount;
    },
    updateCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    updateFilter(state, action) {
      state.pages = {};
      state.totalCount = 0;
      state.filter = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setSort(state, action) {
      state.pages = {};
      state.totalCount = 0;
      state.sort = action.payload;
    },
  },
});

export const vendorManagementActions = vendorManagementSlice.actions;
export default vendorManagementSlice.reducer;
